import React from 'react';
import {
  Euro,
  BarChart3,
  Users,
  UserX,
  Clock,
  Timer,
} from 'lucide-react';
import type { KpiCardData } from './types';

const iconMap = {
  euro: Euro,
  bar: BarChart3,
  users: Users,
  late: UserX,
  clock: Clock,
  overtime: Timer,
};

interface KpiCardsProps {
  cards: KpiCardData[];
  loading?: boolean;
}

const KpiCards: React.FC<KpiCardsProps> = ({ cards, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 h-28 animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6 gap-4">
      {cards.map((card) => {
        const Icon = iconMap[card.icon];
        return (
          <div
            key={card.title}
            className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex items-start justify-between"
          >
            <div className="min-w-0">
              <p className="text-xs text-gray-500 font-medium truncate">{card.title}</p>
              <p className="text-2xl font-bold text-gray-900 mt-1">{card.value}</p>
              <p className={`text-xs mt-1.5 font-medium ${card.trendColor}`}>{card.trend}</p>
            </div>
            <div className={`flex-shrink-0 p-2.5 rounded-full ${card.iconBg}`}>
              <Icon className={`h-4 w-4 ${card.iconColor}`} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KpiCards;
